var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-home-1059986",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.328,
    height: 16.798,
    viewBox: "0 0 19.328 16.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group_1425",
    "data-name": "group 1425",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_1028",
    "data-name": "path 1028",
    d: "M9.622,15.02a1.832,1.832,0,1,1,1.832-1.832A1.832,1.832,0,0,1,9.622,15.02m9.7-.374a1.5,1.5,0,0,0-.57-1.03l-7.9-6.2a1.917,1.917,0,0,0-2.375,0l-7.9,6.2A1.513,1.513,0,0,0,.35,15.773a1.535,1.535,0,0,0,2.116.208l.378-.3v6.4A1.719,1.719,0,0,0,4.561,23.8H7.267a.4.4,0,0,0,.4-.4V20.979a1.968,1.968,0,0,1,3.935,0V23.4a.4.4,0,0,0,.4.4h2.771a1.718,1.718,0,0,0,1.717-1.717v-6.4l.378.3a1.535,1.535,0,0,0,2.117-.208,1.5,1.5,0,0,0,.341-1.127",
    transform: "translate(0 -7)",
    fill: "#5a5a5a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.f03996d9d9fbb556122f5a5cfe411d26.svg";
export { ForwardRef as ReactComponent };